/**
 * Data parsing Helper class
 */
export default class DataParser {
    /**
     * @description Filter exclude unwanted data from back end
     * @param {Object} inputData data from back end
     * @param {Object} tableProps filter data by json properties
     * @param {string} mappedKeys key in object with array of accepted keys
     * @requires json object with properties/settings
     * @returns key value pairs
     */

    filterDataByKeys(inputData, jsonProps, mappedKeys) {
        let data = {};
        const props = jsonProps;

        for (let [itemIndex, itemValue] of inputData.entries()) {
            if (inputData[itemIndex][props.key] !== null) {
                let mergedData = [].concat(
                    Object.entries(inputData[itemIndex]).slice(0, -1),
                    Object.entries(inputData[itemIndex][props.key])
                );

                data[itemIndex] = mergedData.map((value, key) => {
                    if (props[mappedKeys].includes(value[0])) {
                        return ([key] = value);
                    }
                });

                data[itemIndex] = data[itemIndex].filter((element) => {
                    return element !== undefined;
                });
            }
        }

        return data;
    }
}
